import Vue from 'vue';
import { install } from 'vue-demi';
import { teamworkUI } from '@teamwork/ui-kit';
import PortalVue from 'portal-vue';
import router from '@/platform/router';
import App from '@/App.vue';
import i18n from '@/i18n';

import '@/assets/vuetify.scss';
import '@teamwork/ui-kit/dist/ui-kit.esm.css';
import '@/assets/tailwind.css';

install(Vue);

Vue.config.productionTip = false;
Vue.use(PortalVue);

new Vue({
  router,
  i18n,
  ...teamworkUI,
  render: (h) => h(App),
}).$mount('#app');
